import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from '../service/translation.service';
import { NavtabsComponent } from '../components/navtabs/navtabs.component';
import { NavbarComponent } from '../components/navbar/navbar.component';

/**
 * Call component navtab if user have the Security Policies role else error403
 */
@Component({
    selector: 'app-security-policies',
    templateUrl: './security-policies.component.html',
    styleUrls: ['./security-policies.component.scss'],
    standalone: true,
    providers: [TranslationService],
    imports: [NavtabsComponent, NavbarComponent]
})
export class SecurityPoliciesComponent implements OnInit, OnDestroy {
  
  readonly translationService = inject(TranslationService);

  ngOnDestroy(): void {
    document.body.style.backgroundColor="white";
  }

  ngOnInit(): void {
    this.translationService.get('menu-security-policies').subscribe((translation: string) => {
      document.title = "DIP - " + translation;
    });
    document.body.style.backgroundColor="#F1F1F4";
  }

}
